function getHeaderElement() {
  return document.getElementsByClassName(
    "shopify-section-group-header-group"
  )[0];
}

function getHeaderHeight() {
  const headerElement = getHeaderElement();
  return headerElement.clientHeight;
}
